import axios from "axios";
import Image from "next/image";
import { conditions, getUUID } from "../../../../../../helpers";
import { ConditionName } from "../../../../../../interfaces";
import { useAppSelector } from "../../../../../../redux/hooks";
import { shallowEqual } from 'react-redux'

const AdIcon = () => {
    
    const { ads } = useAppSelector(({ videoData: { ads } }) => ({ ads }), shallowEqual);
    const {iconSrc, iconText, iconDestination, iconUrl} = ads

    return (
        <div
            onClick={() => {
                (async () => {
                    try {
                        const uuidObj = {"uuid": getUUID()};
                        const response = await axios({
                            url: iconUrl,
                            method: "get",
                            headers: {},
                            data: uuidObj
                        });
                    } catch (error) {
                        console.error(error)
                    }
                })()
                window.open(`https://${iconDestination}`, '_blank')
            }}
            className={`pl-flex pl-gap-2 pl-items-center pl-cursor-pointer pl-w-max pl-absolute pl-bg-secondary-700/[0.8] pl-rounded-r-[8px] pl-text-white pl-font-[700] pl-left-0 pl-pl-[5px] ${conditions(ConditionName.isTouchScreen) ? `pl-text-[12px] pl-bottom-[42px] ${!!iconSrc ? "!pl-h-max" : "pl-h-[48px]"}` : "pl-text-[16px] pl-bottom-[148px] pl-h-[72px]"}`}>
            {
                !!iconSrc && (
                    <div
                        className={`pl-relative ${conditions(ConditionName.isTouchScreen) ? "pl-h-[48px] pl-max-w-[62px]" : "pl-h-[72px] pl-max-w-[80px]"}`}>
                        <Image src={iconSrc} width={conditions(ConditionName.isTouchScreen) ? 48 : 72} height={conditions(ConditionName.isTouchScreen) ? 48 : 72}/>
                    </div>
                )
            }
            {
                !!iconText && (
                    <div
                        className={`pl-flex pl-items-center pl-self-center ${conditions(ConditionName.isTouchScreen) && (!!iconSrc ? "pl-max-w-[62px] pl-h-[72px]" : "pl-max-w-[150px]")} ${!iconSrc && "pl-p-2"}`}>
                        {iconText}
                    </div>
                )
            }
        </div>
    )
}

export default AdIcon;